import scrubber from "./scrubber";

export default {
	modules: {
		scrubber
	},
	actions: {
		async getSchedule(store) {
			try {
				const res = await window.request("GET", "/schedule");

				return res.data;
			} catch (err) {
				store.commit("setRequestErrorMessage", err.response.data);
				throw err;
			}
		},
		async updateSchedule(store, payload) {
			try {
				const res = await window.request("PUT", "/schedule", payload);

				return res.data;
			} catch (err) {
				store.commit("setRequestErrorMessage", err.response.data);
				throw err;
			}
		},
		async getLimits(store) {
			try {
				const res = await window.request("GET", "/processinglimits/current");

				return res.data;
			} catch (err) {
				store.commit("setRequestErrorMessage", err.response.data);
				throw err;
			}
		},
		async updateLimits(store, payload) {
			try {
				const res = await window.request("PUT", "/processinglimits", payload);
				store.commit("setActivityControlStatus", res.data.activityControlEnabled);
				return res.data;
			} catch (err) {
				store.commit("setRequestErrorMessage", err.response.data);
				throw err;
			}
		},
		async getTransactions(_, payload) {
			const res = await window.request("GET", "/v1/shared/billings/transactions", payload);

			return res.data;
		},
		async getUserScheduleByAdmin(store, userId) {
			const res = await window.request("GET", `/schedule/admin/${userId}`);

			return res.data;
		},
		async resetUserSchedule(store, userId) {
			try {
				const res = await window.request(
					"POST",
					`/schedule/admin/${userId}/reset-timezone-limit`,
					{ updatedAt: null }
				);

				return res.data;
			} catch (err) {
				store.commit("setRequestErrorMessage", "Unable to reset the daily limit at this time. Please try again later");

				throw err;
			}
		},

	}
};
